import { Injectable, Type } from "@angular/core";
import type { ToolBarComponentInterface } from '@nts/std/interfaces';

@Injectable({
    providedIn: 'root'
})
export class ToolbarComponentRegistry {
    private registry: Map<string, Type<ToolBarComponentInterface>> = new Map();

    register(key: string, component: Type<ToolBarComponentInterface>): void {
        this.registry.set(key, component);
        // console.log(`Toolbar component registered: ${key}`);
    }

    get(key: string): Type<ToolBarComponentInterface> | undefined {
        return this.registry.get(key);
    }

    has(key: string): boolean {
        return this.registry.has(key);
    }

    clear(): void {
        this.registry.clear();
    }
}
